<template>
    <el-carousel :interval="3000" @change="changeHandle" class="sliders" :height="clientHeight" margin-top="-30px" :autoplay="true" >
      <el-carousel-item v-for="banner in banners" :key="banner.name" :style="banner.style">
     </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
  data() {
    return {
      nowTitle: 'SASC', // 当前展示的内容
      show: false, // 是否展示标题和内容
      clientHeight: `${document.documentElement.clientWidth * (913 / 1920)}px`,
      banners: [
        {
          name: 'CF',
          style: {
            backgroundImage: `url(${require('../assets/images_new/home_2.jpg')})`,
            backgroundSize: '100% %',
            height: '100%',
          },
        },
        {
          name: 'LS',
          style: {
            // backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_3.jpg')`,
            backgroundImage: `url(${require('../assets/images_new/home_4.jpg')})`,
            backgroundSize: '100% %',
            height: '100%',
          },
        },
        {
          name: 'DF',
          style: {
            // backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_4.jpg')`,
            backgroundImage: `url(${require('../assets/images_new/new_home_4.jpg')})`,
            backgroundSize: '100% %',
            height: '100%',
          },
        },
        {
          name: 'VF',
          style: {
            // backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_4.jpg')`,
            backgroundImage: `url(${require('../assets/images_new/vf_home_v3.jpg')})`,
            backgroundSize: '100% %',
            height: '100%',
          },
        },
      ],
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
    };
  },
  methods: {
    // 切换图片后，暂时隐藏标题和内容，一秒后再重新显示
    changeHandle(index) {
      this.show = false;
      const that = this;
      setTimeout(() => {
        this.nowTitle = this.banners[index].name;
        that.show = true;
      }, 1000);
    },
  },
  mounted() {
    // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
    const that = this;
    window.onresize = function temp() {
      that.clientWidth = `${document.documentElement.clientHeight}px`;
    };
  },
};
</script>


<style lang="less" scoped>

.sliders{
  overflow: hidden;
  .content{
      z-index:5;
      color: white;
      position  : absolute;
      top       : 50%;
      left      : 50%;
      transform : translate(-50%,-50%);
      h1{
        font-size: 120px;
        font-weight: 800;
        margin: 0px;
        text-align: center;
      }
      h2{
        font-size: 60px;
        font-weight: 600;
        margin: 0px;
        text-align: center;

      }
    }

  .el-carousel__item {
    /* Center and scale the image nicely */
    /* 优雅的图片居中自适应方案 */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow:hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue